import React, { useState } from 'react';

function Consent({ onComplete }) {
  const [agreed, setAgreed] = useState(false);

  return (
    <div className="phase-container">
      <h1>Informed Consent</h1>
      
      <div className="consent-text">
        <h2>Study Information</h2>
        <p>
          You are invited to participate in a research study on visual perception of 
          artistic style. This is a mockup demonstration.
        </p>
        
        <h2>What You Will Do</h2>
        <p>
          You will view pairs of images and judge which better represents the style of 
          various artists. The study takes approximately 25-35 minutes.
        </p>
        
        <h2>Data Collection</h2>
        <p>
          This mockup stores data locally in your browser only. No data is transmitted 
          to any server. You can export your responses at the end if desired.
        </p>
        
        <h2>Voluntary Participation</h2>
        <p>
          Participation is voluntary. You may stop at any time.
        </p>
      </div>
      
      <div className="checkbox-group">
        <label className="checkbox-option">
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
          />
          <span>
            I have read and understood the information above. I agree to participate 
            in this research study.
          </span>
        </label>
      </div>
      
      <div className="button-group">
        <button 
          onClick={onComplete}
          disabled={!agreed}
        >
          Continue
        </button>
      </div>
    </div>
  );
}

export default Consent;